import * as React from 'react';
import { injectIntl } from 'react-intl';
import { toast } from 'react-toastify';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Error boundary caught', error, info);

    const message = this.props.intl.formatMessage({
      id: 'unknown-error',
      defaultMessage: 'Something went wrong. Click here to reload.',
    });

    toast.error(message, {
      autoClose: false,
      onClick: () => window.location.reload(),
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default injectIntl(ErrorBoundary);
